// Interruptor de teste local. Ausente ou `false`, tudo se comporta como sempre: a SideBar busca a
// loja no Plus e os popups saem do que a requisição trouxer.
//
// No .env do projeto:
//
//     empreender_ui_dev=true
//
// Underscore, não hífen: o Vite transforma a chave em `define` de `import.meta.env.<chave>` e o
// esbuild recusa o que não for identificador JS válido — com hífen o `vite build` quebra (o dev
// passa, o build não). E como ela não tem o prefixo `VITE_`, precisa estar liberada no
// `vite.config.ts` do projeto: `envPrefix: ['VITE_', 'empreender_ui_dev']`.
export const DEV = import.meta.env?.empreender_ui_dev === 'true';
